var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLanguageArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 9,
    viewBox: "0 0 17 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.91515 7.26331C8.89192 7.28659 8.86434 7.30506 8.83396 7.31767C8.80359 7.33027 8.77103 7.33676 8.73815 7.33676C8.70526 7.33676 8.6727 7.33027 8.64233 7.31767C8.61196 7.30506 8.58437 7.28659 8.56115 7.26331L2.19715 0.899312C2.12848 0.825624 2.04568 0.766522 1.95368 0.725531C1.86168 0.684539 1.76237 0.662496 1.66167 0.660719C1.56097 0.658942 1.46094 0.677468 1.36755 0.715189C1.27416 0.75291 1.18933 0.809054 1.11811 0.880273C1.04689 0.951492 0.990744 1.03633 0.953023 1.12971C0.915302 1.2231 0.896777 1.32313 0.898554 1.42383C0.900331 1.52454 0.922373 1.62385 0.963364 1.71585C1.00436 1.80785 1.06346 1.89065 1.13715 1.95931L7.50015 8.32331C7.66265 8.48583 7.85558 8.61475 8.06791 8.70271C8.28024 8.79067 8.50782 8.83594 8.73765 8.83594C8.96747 8.83594 9.19505 8.79067 9.40738 8.70271C9.61971 8.61475 9.81264 8.48583 9.97515 8.32331L16.3391 1.95931C16.4716 1.81714 16.5437 1.62909 16.5403 1.43479C16.5369 1.24049 16.4582 1.0551 16.3208 0.91769C16.1834 0.780277 15.998 0.701566 15.8037 0.698137C15.6094 0.694709 15.4213 0.766831 15.2791 0.899312L8.91515 7.26331Z",
    fill: "#282828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageArrow);
export default __webpack_public_path__ + "static/media/language-arrow.53a40fdbb64e394a30f3562ca638cc18.svg";
export { ForwardRef as ReactComponent };